import { useCallback, useEffect, useState } from "react";
import { useAuth } from "../../../contexts/auth/auth-context";

type UsePasswordLoginArgs = {
    onSuccess?: () => void;
};

export const usePasswordLogin = ({ onSuccess }: UsePasswordLoginArgs) => {
    const { email, password, setPassword, loading, error, signinWithPassword } =
        useAuth();
    const [localPassword, setLocalPassword] = useState(password);

    useEffect(() => {
        setLocalPassword(password);
    }, [password]);

    const submit = useCallback(async () => {
        // sync local -> context
        setPassword(localPassword);

        // do the actual login
        await signinWithPassword();

        if (onSuccess) onSuccess();
    }, [localPassword]);

    return {
        email,
        password: localPassword,
        setPassword: setLocalPassword,
        loading,
        error,
        submit,
    };
};
